import React from 'react';

import { bemBlock } from '../../modules/bem';
import { Layout } from '../layout/Layout';

import { getDataRole } from './Panel.helpers';
import { type DataRoleProps } from './Panel.types';

import './PanelRoot.less';

const block = bemBlock('n-Panel');

export type PanelRootProps = React.HTMLAttributes<HTMLDivElement> &
  DataRoleProps & {
    gap?: 'lg' | 'md' | 'none' | 'sm';
  };

export const PanelRoot = React.forwardRef<HTMLDivElement, PanelRootProps>(function PanelRoot(
  { children, className, dataRole, gap = 'md', 'data-role': dataRoleAttribute, ...passProps },
  ref,
) {
  return (
    <Layout.Element
      {...passProps}
      elementRef={ref}
      className={block({ modifiers: { gap }, extra: className })}
      data-role={getDataRole(dataRole, dataRoleAttribute)}
    >
      {children}
    </Layout.Element>
  );
});
